// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyA1h5crWqn36Bwyp4Ap0Cpp3s_8iGaddbQ",
    authDomain: "gamerskingdom-app.firebaseapp.com",
    databaseURL: "https://gamerskingdom-app.firebaseio.com",
    projectId: "gamerskingdom-app",
    storageBucket: "gamerskingdom-app.appspot.com",
    messagingSenderId: "401572647040",
    appId: "1:401572647040:web:076ba3607ff11084b75665",
    measurementId: "G-5FXQS279XQ"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
